import React from "react";
import { FormControl, InputLabel, OutlinedInput, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";

const MenuItemFilter = React.memo(
  ({ label, value, onChange, filters, noEmpt, emptyLabel, style }) => {
    const { t } = useTranslation();
    return (
      <FormControl
        size="small"
        sx={{
          minWidth: 180,
          maxWidth: { xs: "none", sm: 360 },
          width: { xs: "100%", sm: "auto" },
          flexShrink: 1,
          flexGrow: 0,
          ...style,
        }}
      >
        <InputLabel id={`${label}-filter-label`}>{label}</InputLabel>
        <Select
          labelId={`${label}-filter-label`}
          id={`${label}-filter`}
          value={value ?? ""}
          onChange={onChange}
          input={<OutlinedInput label={label} />}
          sx={{
            "& .MuiSelect-select": {
              paddingTop: "6px !important",
              paddingBottom: "6px !important",
              paddingRight: "44px !important",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            "& .MuiSelect-icon": {
              right: 10,
            },
          }}
        >
          {!noEmpt && (
            <MenuItem key="all" value="">
              {emptyLabel || label}
            </MenuItem>
          )}
          {filters?.map((filter) => (
            <MenuItem key={filter._id} value={filter._id}>
              {filter.labelKey ? t(filter.labelKey) : filter.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
);

export default MenuItemFilter;
